import { render, staticRenderFns } from "./MenuLeft.vue?vue&type=template&id=13b47430&scoped=true&"
import script from "./MenuLeft.vue?vue&type=script&lang=js&"
export * from "./MenuLeft.vue?vue&type=script&lang=js&"
import style0 from "./MenuLeft.vue?vue&type=style&index=0&id=13b47430&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b47430",
  null
  
)

export default component.exports